package com.iregained.site.components.sections.distributors.styles

import com.iregained.site.theme.toSitePalette
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.selectors.hover
import org.jetbrains.compose.web.css.*

val LocatorHeroStyle = CssStyle {
    base {
        Modifier.fillMaxWidth().styleModifier {
            property("height", "calc(100dvh - 80px)")
            property("background-size", "cover")
            property("background-position", "center")
        }.minHeight(600.px)
    }
}

val LocatorHeroOverlayStyle = CssStyle {
    base {
        Modifier.fillMaxSize().backgroundColor(rgba(0, 0, 0, 0.7f)).padding(topBottom = 60.px, leftRight = 20.px)
            .display(DisplayStyle.Flex).flexDirection(FlexDirection.Column)
            .justifyContent(com.varabyte.kobweb.compose.css.JustifyContent.Center)
            .alignItems(com.varabyte.kobweb.compose.css.AlignItems.Center)
    }
}

val LocatorTwoPaneContainerStyle = CssStyle {
    base {
        Modifier.width(90.percent).maxWidth(1400.px).margin(top = 50.px, bottom = 50.px).backgroundColor(Colors.White)
            .borderRadius(12.px).boxShadow(0.px, 0.px, 40.px, color = rgba(0, 0, 0, 0.15f))
            .overflow(Overflow.Hidden) // Ensures the map/list respect the rounded corners
            .zIndex(10)
    }
}

val DistributorListItemStyle = CssStyle {
    base {
        Modifier.fillMaxWidth().padding(20.px).cursor(Cursor.Pointer)
            .transition(Transition.of("background-color", duration = 200.ms))
    }
    hover {
        Modifier.backgroundColor(rgba(0, 128, 128, 0.05f)) // Subtle Teal Hover
    }
}

val LocatorSearchInputStyle = CssStyle {
    base {
        val palette = colorMode.toSitePalette() // <-- Add this
        Modifier.fillMaxWidth().padding(14.px).borderRadius(6.px).border(1.px, LineStyle.Solid, Colors.LightGray)
            .backgroundColor(Colors.White) // <-- FORCES WHITE BACKGROUND
            .color(palette.custom.darkText) // <-- FORCES DARK TEXT
            .fontSize(16.px).outline(0.px).transition(Transition.of("border-color", duration = 200.ms))
    }
}